import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams } from 'ionic-angular';
import { Globals } from "../../../../globals";
import { ConfigurationServices } from "../../services";

/**
 * Generated class.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-configuration-close-cash-view-print',
  templateUrl: 'configuration-close-cash-view-print.html',
})
export class ConfigurationCloseCashViewPrintPage {

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public globals: Globals,
    public configurationServices: ConfigurationServices) {
  }

  trFontColor(ticket) {
    if (ticket.refund && ticket.amount < 0) {
      let cssClasses = {
        'text-danger': true,
      };
      return cssClasses;
    }
    return '';
  }
}



// WEBPACK FOOTER //
// ./src/pages/configuration/configuration-close-cash/configuration-close-cash-view-print/configuration-close-cash-view-print.ts